<template>
  <div>
      <div class="opcoess">
            <div :class="{atual:1 == atual}" @click="ClickAtual(1,'/sandboxfront/img/protecaoBranca.svg','Visão Geral')">
                <img src="/sandboxfront/img/protecaoBranca.svg" alt="" v-if="atual ==1">
                <img src="/sandboxfront/img/protecao.svg" alt="" v-else>
                <span>Visão Geral</span>
            </div>
            <div :class="{atual:2 == atual}" @click="ClickAtual(2,'/sandboxfront/img/documentoBranco.svg','Legislação')">
                <img src="/sandboxfront/img/documentoBranco.svg" alt="" v-if="atual == 2">
                 <img src="/sandboxfront/img/documento.svg" alt="" v-else>
                <span>Legislação</span>
            </div>
            <div :class="{atual:3 == atual}" @click="ClickAtual(3,'/sandboxfront/img/brasil2Branco.svg','Aplicação Federal')">
                <img src="/sandboxfront/img/brasil2Branco.svg" alt="" v-if="atual == 3">
                <img src="/sandboxfront/img/brasil2.svg" alt="" v-else>
                <span>Aplicação Federal </span>
            </div>
            <div :class="{atual:4 == atual}" @click="ClickAtual(4,'/sandboxfront/img/bilheteBranco.svg','Aplicação Fiscal')">
                <img src="/sandboxfront/img/bilheteBranco.svg" alt="" v-if="atual == 4">
                <img src="/sandboxfront/img/bilhete.svg" alt="" v-else>
                <span>Aplicação Fiscal</span>
            </div>
            <div :class="{atual:5 == atual}" @click="ClickAtual(5,'/sandboxfront/img/platilhaBranco.svg','Aplicação Trabalhista')">
                <img src="/sandboxfront/img/platilhaBranco.svg" alt="" v-if="atual == 5">
                <img src="/sandboxfront/img/platilha.svg" alt="" v-else>
                <span>Aplicação Trabalhista</span>
            </div>
      </div>
      <div class="atualheader">
        <img :src="img" width="30px" height="30px"> {{txt}} 
      </div>
      <VisaoGeral v-if="$route.params.id == 1"/>
      <Legislacao v-if="$route.params.id == 2" /> 
      <Federal v-if="$route.params.id == 3" />
      <Fiscal v-if="$route.params.id == 4" />
      <Trabalhista v-if="$route.params.id == 5" />
  </div>
</template>

<script>
import VisaoGeral from '../shared/VisaoGeral.vue'
import Legislacao from '../shared/Legislacao.vue'
import Federal from '../shared/Federal.vue'
import Trabalhista from '../shared/Trabalhista.vue'
import Fiscal from '../shared/Fiscal.vue'
export default {
    components:{
        VisaoGeral ,
        Legislacao,
        Federal,
        Trabalhista,
        Fiscal
    },
    data(){
        return{
            atual:false,
            txt:'',
            img:''
        }
    },
    methods:{
        ClickAtual(ia,img,txt){
            this.$router.push({name:'op',params:{id:ia}})
            this.atual= ia
            this.img = img
            this.txt = txt        
        }
    },
    mounted(){
   
        let rota = this.$route.params.id
        if(rota ==1){
            this.txt = 'Visão Geral'
            this.atual = 1
        }else if(rota ==2){
            this.txt = 'Legislação'
            this.atual = 2
        }else if(rota == 3){
            this.txt = 'Aplicação Federal'
            this.atual = 3
        }else if(rota == 4){
            this.txt = 'Aplicação Fiscal'
            this.atual = 4
        }else if(rota == 5){
            this.txt = 'Aplicação Trabalhista'
            this.atual = 5
        }
    }
}
</script>

<style>
.atualheader{
     background: #4A154B ;
     padding:15px 25px;
     color:#fff;
         display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
}
.atual{
    background: #4A154B !important;
}
.atual span{
    color:#FFFFFF !important
}
.opcoess{
    display: flex;
    align-items: center;
   justify-content: center;
   margin-top:30px;
}
.opcoess div{
    background: #EDE4ED;
    color: #4A154B;
    font-weight: bold;
    padding: 6px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #4A154B;
    border-bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-left: 10px;
    font-size: 14px;
}
.opcoess div img{
    width: 50px;
    height: 42px;
}
.opcoess div span{
    margin-left: 5px;
}
@media screen and (max-width: 600px) {
    .opcoess div img {
        width: 35px;
        height: 35px;
    }
    .opcoess div {
    background: #EDE4ED;
    color: #4A154B;
    font-weight: bold;
    padding: 6px 19px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
     border: none; 
    border-bottom: 0;
     border-top-left-radius: 0px; 
     border-top-right-radius: 0px; 
     margin-left: 0px;
    font-size: 16px;
    width: 100%;
    }
    .opcoess{
        flex-direction: column;
    }
}
</style>